import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.section`
  min-height: fit-content;
  display: flex;
  flex-direction: row;
  padding: 5px;
  border-radius: ${({ theme }) => theme.metrics.radius};
  background-color: ${({ theme }) => darken(0.05, theme.colors.background)};

  table {
    width: 100%;
    font-size: 12px;
    border-radius: ${({ theme }) => theme.metrics.innerRadius};
    border-collapse: collapse;
    overflow: hidden;

    thead {
      background-color: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.textPrimary};

      tr:first-child {
        th {
          padding: 10px;
          text-transform: capitalize;
          text-align: left;
          font-size: 16px;
        }
      }

      tr:last-child {
        th {
          background-color: ${({ theme }) => darken(0.1, theme.colors.background)};
          color: ${({ theme }) => theme.colors.textBackground};

          &:first-child {
            width: 180px;
          }
        }
      }

      tr {
        th {
          padding: 5px;
          text-transform: uppercase;
          text-align: left;
        }
      }
    }

    tbody {
      tr {
        background-color: ${({ theme }) => theme.colors.background};
        transition: 0.2s;
        cursor: pointer;

        &:nth-child(odd) {
          background-color: ${({ theme }) => darken(0.025, theme.colors.background)};

          td {
            &.feriado {
              background-color: ${({ theme }) => darken(0.025, theme.colors.error)};
            }
          }
        }

        td {
          padding: 5px;
          font-size: 11px;
          color: ${({ theme }) => theme.colors.textBackground};

          &.feriado {
            background-color: ${({ theme }) => theme.colors.error};
          }
        }

        &:hover {
          background-color: ${({ theme }) => darken(0.05, theme.colors.background)};

          td {
            &.feriado {
              background-color: ${({ theme }) => darken(0.05, theme.colors.error)};
            }
          }
        }
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.metrics.tablet_medium}) {
    margin: 0;
    overflow-x: auto;
  }
`;

export const ContainerMes = styled.div`
    display: none;
    writing-mode: vertical-rl;
    text-orientation: upright;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 12px;
    padding: 10px;
    text-align: center;
    vertical-align: middle;
    border: 1px solid black;
    border-right: none;

    @media print {
      display: block;
    }
`;